import { GetClassiFicareTree } from '@/api'
import router from '@/router'
import { getTreeIds } from "@/libs/utils.js"
export default {
  state: {
    tree: [], //所有菜单
    active: -1, //主导航选中
    subActive: -1, //次级导航选中
    subTree: [], //侧边栏菜单

    ontree: [], //选中树结构

    ISPC: true

  },
  mutations: {
    SET_tree(state, data) {
      state.tree = data
    },

    SET_subTree(state, param) {
      state.subTree = param;
    },
    SET_subActive(state, param) {
      state.subActive = param;
    },
    SET_active(state, param) {
      state.active = param;
    },
    SET_ontree(state, param) {
      state.ontree = param;
    },
    SER_ISPC(state, param) {
      state.ISPC = param;
    }
  },


  actions: {
    //获取所有菜单
    GetClassiFicareTree({ commit }) {
      return new Promise((resolve, reject) => {
        GetClassiFicareTree().then(res => {
          commit('SET_tree', res)
          // router.app._route.query.scode
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    //遍历路由
    TraverseTree({ commit, state }, onescode) {
      var temData = new URLSearchParams(window.location.search);
      let scode = temData.get('scode') ? temData.get('scode') : onescode
      let mcode = temData.get('mcode')
      if ((temData.get('pmcode') == 4 || temData.get('pmcode') == 7) && temData.get('id')) {
        scode = temData.get('z')
      }
      if (!scode) {
        // router.push("/");
        return
      }
      let tree = state.tree
      let temptArr = [];
      temptArr = getTreeIds(tree, scode).reverse()


      commit('SET_ontree', temptArr)

      //侧边栏
      let subTree = subTree = temptArr[temptArr.length - 2].subs;

      // if(mcode==4){ //业务领域菜单不在侧边栏显示
      //   subTree = temptArr[0].subs;
      //   debugger
      // }
      // if (temptArr[temptArr.length - 1].subs && temptArr[temptArr.length - 1].subs.length) {
      //   subTree = temptArr[temptArr.length - 1].subs;
      // } else {
      //   subTree = temptArr[temptArr.length - 2].subs;
      // }
      commit('SET_subActive', scode)
      commit('SET_subTree', subTree)
      commit('SET_active', temptArr[0].scode)

      console.log("技术支持：江苏绿茶网络科技有限公司");
      console.log('官网链接：https://www.jsgtkj.com');

    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/user.js